import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src={process.env.REACT_APP_LOGO_URL} 
              alt="Cautela Defence Services" 
              className="h-10 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors duration-200 ${
                isScrolled ? 'text-slate-700 hover:text-cautela-green' : 'text-white hover:text-cautela-green'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('capabilities')}
              className={`text-sm font-medium transition-colors duration-200 ${
                isScrolled ? 'text-slate-700 hover:text-cautela-green' : 'text-white hover:text-cautela-green'
              }`}
            >
              Capabilities
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors duration-200 ${
                isScrolled ? 'text-slate-700 hover:text-cautela-green' : 'text-white hover:text-cautela-green'
              }`}
            >
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-cautela-purple hover:bg-cautela-purple-dark text-white transition-all duration-300 hover:scale-105"
            >
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className={isScrolled ? 'text-slate-900' : 'text-white'} size={24} />
            ) : (
              <Menu className={isScrolled ? 'text-slate-900' : 'text-white'} size={24} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-200 shadow-xl">
          <nav className="px-4 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-slate-700 hover:text-cautela-green font-medium py-2"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('capabilities')}
              className="block w-full text-left text-slate-700 hover:text-cautela-green font-medium py-2"
            >
              Capabilities
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left text-slate-700 hover:text-cautela-green font-medium py-2"
            >
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="w-full bg-cautela-purple hover:bg-cautela-purple-dark text-white"
            >
              Get Started
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;